class ContactEdit {
    constructor(data = {}) {
      this.idContacto = data.idContacto || 0;
      this.nombre = data.nombre || "";
      this.correo = data.correo || "";
    }
  }
  
  class ContactAdd {
    constructor(data = {}) {
      this.idContacto = data.idContacto || 0;
      this.nombre = data.nombre || "";
      this.correo = data.correo || "";
    }
  }
  
  export { ContactEdit, ContactAdd };